module.exports = __webpack_public_path__ + "static/media/overview-hsd-summary-activity-icon.c602a0b2.png";